export default "__VITE_ASSET__DZHYEHkU__";